import { get, isBoolean, isEmpty, map, set } from 'lodash';
import getAge from '../../../../../helpers/getAge';
import { isBroker } from '../../../../auth/redux/authActions';
const META = 'data.attributes.metadata';

const validateCommunicationOptions = (value, salesChannel, email, mobile) => {
  const isB2B = ['jtc-brokers', 'jtc-b2b'].includes(salesChannel);
  const isEmailEnabled = !!value?.email;
  const isPostEnabled = !!value?.post;
  const isSmsEnabled = !!value?.sms;

  const hasCommunicationOption = isPostEnabled || isEmailEnabled;
  if (!isB2B && !isBroker()) {
    if (!hasCommunicationOption) {
      return 'Please select at least one communication option';
    }
  }
  if (isEmailEnabled && !email) {
    return 'An email address is required for email communication';
  }
  if (isSmsEnabled && !mobile) {
    return 'A mobile number is required for sms communication';
  }
};

const validate = (values) => {
  const errors = {};
  let currentTab = get(values, 'data.current_tab');
  // const mta = get(values, 'data.mta')
  const medicalTab = 3;
  const REVIEW_DETAILS_TAB = 5;
  const TRIP_DETAILS_TAB = 1;
  const requiredFields = [
    { field: 'data.attributes.metadata.scheme_type', name: 'Type of cover' },
    { field: 'data.attributes.metadata.start_date', name: 'Start date' },
  ];

  requiredFields.map((required) => {
    if (!get(values, required.field)) {
      set(errors, required.field, required.name + ' is required');
    }
  });

  // Group Type validation
  if (get(values, 'data.attributes.metadata.traveller_group') === '') {
    set(errors, 'data.attributes.metadata.traveller_group', 'Group Type is required');
  }

  if (get(values, 'data.attributes.metadata.scheme_type') === 'annual') {
    if (!get(values, 'data.attributes.metadata.region')) {
      set(errors, 'data.attributes.metadata.region', 'Please select a region');
    }
  } else {
    const destinations = get(values, 'data.attributes.metadata.destinations', []);
    if (!destinations || destinations.length === 0) {
      set(errors, 'data.attributes.metadata.destinations', 'Please select a destination');

      if (!get(values, 'data.attributes.metadata.end_date')) {
        set(errors, 'data.attributes.metadata.end_date', 'End date is required');
      }
    }
  }

  const renewalDec = values?.data?.attributes?.metadata?.renewal_declaration;
  if (renewalDec) {
    if (renewalDec.answer !== true){
      set(errors, 'data.attributes.metadata.renewal_declaration.answer', 'Please agree to the above declaration');
    }

  }

  if (get(values, 'data.attributes.metadata.scheme_type') === 'annual') {
    if (!get(values, 'data.attributes.metadata.max_trip_duration')) {
      set(
        errors,
        'data.attributes.metadata.max_trip_duration',
        'Please select the max duration',
      );
    }
  }

  // metadata.adults validation
  get(values, 'data.attributes.metadata.adults', []).map((adult, i) => {
    if (i === 0 && !adult.title) {
      set(
        errors,
        'data.attributes.metadata.adults[' + i + '].title',
        'Title is required',
      );
    }

    if (i === 0 && !adult.first_name) {
      set(
        errors,
        'data.attributes.metadata.adults[' + i + '].first_name',
        'First name is required',
      );
    }

    if (i === 0 && !adult.last_name) {
      set(
        errors,
        'data.attributes.metadata.adults[' + i + '].last_name',
        'Last name is required',
      );
    }

    if (get(adult, 'age', '') === '') {
      set(errors, 'data.attributes.metadata.adults[' + i + '].age', 'Age is required');
    }

    // email validation for the lead traveller
    if (i === 0 && !isEmpty(adult.email)) {
      if (get(values, `${META}.storage.quote_originator.email`) === adult.email) {
        set(
          errors,
          'data.attributes.metadata.adults[' + i + '].email',
          'You must not use use your own email address here, please enter the ' +
            'customers email address as it will be used to register their Smart ' +
            'Luggage service.',
        );
      }

      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i.test(adult.email)) {
        set(
          errors,
          'data.attributes.metadata.adults[' + i + '].email',
          'Invalid email address',
        );
      }
    }

    // Check for DOB Field in REVIEW_DETAILS_TAB
    if (isEmpty(adult.dob) && currentTab === REVIEW_DETAILS_TAB) {
      set(
        errors,
        'data.attributes.metadata.adults[' + i + '].dob',
        'Date of birth is required',
      );
    }

    // compare adult.dob with the field age (in case of manual changing) - review tab
    if (adult.dob) {
      const adultAge = getAge(adult.dob);
      if (adultAge.toString() !== adult?.age?.toString()) {
        set(
          errors,
          `data.attributes.metadata.adults.${i}.dob`,
          'Date of Birth is incorrect for Age entered as of today',
        );
      }
    }

    // Validate the rest of the adult travellers in Review Tab
    if (currentTab === REVIEW_DETAILS_TAB) {
      if (isEmpty(adult.title)) {
        set(
          errors,
          'data.attributes.metadata.adults[' + i + '].title',
          'Title is required',
        );
      }
      if (isEmpty(adult.first_name)) {
        set(
          errors,
          'data.attributes.metadata.adults[' + i + '].first_name',
          'First name is required',
        );
      }
      if (isEmpty(adult.last_name)) {
        set(
          errors,
          'data.attributes.metadata.adults[' + i + '].last_name',
          'Last name is required',
        );
      }
    }
  }); // end of map

  const leadTravellerAge = getAge(
    get(values, 'data.attributes.metadata.adults[0].dob', 0),
  );
  if (leadTravellerAge < 18) {
    set(
      errors,
      'data.attributes.metadata.adults[0].dob',
      'Lead Traveller must be over 18',
    );
  }

  // if (get(values, META + '.communications.sms') === true) {
  //   if (isEmpty(get(values, META + '.adults[0].phone2'))) {
  //     set(errors, META + '.adults[0].phone2', 'Mobile is required');
  //   }
  // }

  if (!isEmpty(get(values, META + '.adults[0].phone2'))) {
    // add regex Validation
    const phoneRegex = /^(07\d{3}?)\s?\d{3}\s?\d{3}$/;
    const phone2 = get(values, META + '.adults[0].phone2');
    if (!phoneRegex.test(phone2)) {
      set(
        errors,
        META + '.adults[0].phone2',
        "Please enter a mobile number which has 11 digits and begins with '07'. Please do not include any spaces.",
      );
    }
  }

  const cruiseCover = get(values, 'data.attributes.metadata.options.cruise_cover');
  if (!isBoolean(cruiseCover)) {
    set(
      errors,
      'data.attributes.metadata.options.cruise_cover',
      'Cruise Cover is required',
    );
  }

  if (currentTab === REVIEW_DETAILS_TAB || currentTab === TRIP_DETAILS_TAB) {
    if (!get(values, 'data.attributes.metadata.adults[0].address.postcode')) {
      set(
        errors,
        'data.attributes.metadata.adults[0].address.postcode',
        'Postcode is required',
      );
    }

    // Validate if there is address in the Review Tab
    if (currentTab === REVIEW_DETAILS_TAB) {
      if (!get(values, 'data.attributes.metadata.adults[0].address.line1')) {
        set(
          errors,
          'data.attributes.metadata.adults[0].address.line1',
          'Address is required',
        );
      }
    }

    // If (Email or SMS) is ticket verify the lead traveller fields
    // if (
    //   get(values, META + '.communications.email') === true &&
    //   currentTab === REVIEW_DETAILS_TAB
    // ) {
    //   if (isEmpty(get(values, META + '.adults[0].email'))) {
    //     set(errors, META + '.adults[0].email', EMAIL_ERROR_MESSAGE);
    //   }
    // }
  }

  // Review Tab Validation for Children
  if (currentTab === REVIEW_DETAILS_TAB) {
    get(values, `${META}.children`, []).map((child, i) => {
      if (isEmpty(child.title)) {
        set(errors, `${META}.children[${i}].title`, 'Title is required');
      }

      if (!child.first_name) {
        set(errors, `${META}.children[${i}].first_name`, 'First name is required');
      }

      if (!child.last_name) {
        set(errors, `${META}.children[${i}].last_name`, 'Last name is required');
      }

      if (isEmpty(child.dob)) {
        set(errors, `${META}.children[${i}].dob`, 'Date of birth is required');
      }
    });

    const metadata = values?.data?.attributes?.metadata;

    const communicationError = validateCommunicationOptions(
      metadata?.communications,
      metadata?.sales_channel,
      metadata?.adults?.[0]?.email,
      metadata?.adults?.[0]?.phone2,
    );

    if (communicationError) {
      set(errors, `${META}.communications`, communicationError);
    }
  }

  // compare child.dob with the field age (in case of manual changing) - review tab
  const children = values?.data?.attributes?.metadata?.children ?? [];
  children.map((child, i) => {
    if (child.dob) {
      const childAge = getAge(child.dob);
      if (childAge.toString() !== child?.age?.toString()) {
        set(
          errors,
          `data.attributes.metadata.children.${i}.dob`,
          'Date of Birth is incorrect for Age entered as of today.',
        );
      }
    }
  });

  // check for the Age
  get(values, 'data.attributes.metadata.children', []).map((child, i) => {
    if (get(child, 'age', '') === '') {
      set(errors, 'data.attributes.metadata.children[' + i + '].age', 'Age is required.');
    }
  });

  get(values, 'data.attributes.metadata.children', []).map((child, i) => {
    if (child.age >= 18) {
      set(
        errors,
        'data.attributes.metadata.children[' + i + '].age',
        'Child must be under 18.',
      );
    }
  });

  /*
    Medical Declaration. Check if all questions were answered by YES or NO
   */
  if (currentTab === medicalTab) {
    map(
      get(values, 'data.attributes.metadata.medical_declaration_questions', {}),
      (declaration, key) => {
        const questionType = declaration.question_type;
        if (
          declaration.type === 'question' &&
          questionType === 'boolean' &&
          declaration.answer == null
        ) {
          set(
            errors,
            'data.attributes.metadata.medical_declaration_questions[' + key + '].answer',
            'Medical declaration is required',
          );
        }
      },
    );
  }
  if (currentTab === medicalTab) {
    const terminalAnswer = get(
      values,
      'data.attributes.metadata.medical_declaration_questions.terminal-question.answer',
    );
    if (terminalAnswer !== undefined && terminalAnswer <= 0) {
      set(
        errors,
        'data.attributes.metadata.medical_declaration_questions.terminal-question',
        'Terminal prognosis must be greater than 0',
      );
    }
  }

  const adminFeeOverride = get(
    values,
    'data.attributes.metadata.overrides.admin_fee_ex_tax',
    0,
  );
  if (adminFeeOverride && !/^\d*\.?\d*$/i.test(adminFeeOverride)) {
    set(
      errors,
      'data.attributes.metadata.overrides.admin_fee_ex_tax',
      'Admin Fee must be a number',
    );
  }

  errors._error = errors.data;
  return errors;
};
export default validate;
